/* =====================================================================
   PB SEARCH (v0.1) — forslag mens man skriver (Shopify predictive search),
   cache pr. søgeord, piletaster + Enter, lukker ved klik udenfor/Esc.
   ===================================================================== */
(function () {
  'use strict';
  var d = document, PB = window.PB;
  if (!PB) return;
  PB.ready(function () {
    Array.prototype.forEach.call(d.querySelectorAll('[data-pb-search]'), function (form) {
      var input = form.querySelector('[data-pb-search-input]'), pop = form.querySelector('[data-pb-search-pop]');
      if (!input || !pop) return;
      var timer = null, last = '', idx = -1;
      function hide() { pop.hidden = true; idx = -1; }
      function url(q) { return (PB.cfg.routes.suggest || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last'; }
      function render(q, data) {
        var r = (data && data.resources && data.resources.results) || {}, prods = r.products || [], cols = r.collections || [];
        var html = '';
        cols.slice(0, 2).forEach(function (c) { html += '<a class="pb-sugg" href="' + PB.esc(c.url) + '"><span class="pb-sugg__t">' + PB.esc(c.title) + '</span></a>'; });
        prods.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? '<img src="' + PB.esc(p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=96') + '" alt="" width="48" height="48" loading="lazy">' : '';
          var price = p.price != null ? '<span class="pb-sugg__p">' + PB.money(Math.round(parseFloat(p.price) * 100)) + '</span>' : '';
          html += '<a class="pb-sugg" href="' + PB.esc(p.url) + '">' + img + '<span><span class="pb-sugg__t">' + PB.esc(p.title) + '</span><br>' + price + '</span></a>';
        });
        if (!html) html = '<p class="pb-sugg__none">' + PB.esc(PB.t('search_none')) + '</p>';
        html += '<a class="pb-sugg__all" href="' + PB.esc((PB.cfg.routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&options[prefix]=last') + '">' + PB.esc(PB.t('search_all').replace('[terms]', q)) + '</a>';
        pop.innerHTML = html; pop.hidden = false; idx = -1;
      }
      input.addEventListener('input', function () {
        var q = input.value.trim(); clearTimeout(timer);
        if (q.length < 2) { hide(); return; }
        timer = setTimeout(function () { last = q; PB.get(url(q), { json: true, ttl: 120000 }).then(function (j) { if (q === last) render(q, j); }).catch(hide); }, 120);
      });
      input.addEventListener('focus', function () { if (pop.innerHTML && input.value.trim().length > 1) pop.hidden = false; });
      input.addEventListener('keydown', function (e) {
        var links = pop.hidden ? [] : pop.querySelectorAll('a');
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { if (!links.length) return; e.preventDefault(); idx = (idx + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length; Array.prototype.forEach.call(links, function (a, i) { a.classList.toggle('is-on', i === idx); }); }
        else if (e.key === 'Enter' && idx > -1 && links[idx]) { e.preventDefault(); location.href = links[idx].href; }
        else if (e.key === 'Escape') hide();
      });
      d.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
    });
  });
})();
